import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IUserPointsCollectionRequest } from '@/shared/model/user-points-collection-request.model';

const baseApiUrl = 'api/user-points-collection-requests';
const baseSearchApiUrl = 'api/_search/user-points-collection-requests?query=';

export default class UserPointsCollectionRequestService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IUserPointsCollectionRequest> {
    return new Promise<IUserPointsCollectionRequest>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IUserPointsCollectionRequest): Promise<IUserPointsCollectionRequest> {
    return new Promise<IUserPointsCollectionRequest>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IUserPointsCollectionRequest): Promise<IUserPointsCollectionRequest> {
    return new Promise<IUserPointsCollectionRequest>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
